import React from 'react';
import styles from './PageHeader.module.css';

/** SRS #8 — one heading pattern for every app screen: eyebrow, title, one-line purpose, actions on the right. */
export const PageHeader: React.FC<{ eyebrow?: string; title: string; subtitle?: React.ReactNode; actions?: React.ReactNode; back?: React.ReactNode }> = ({ eyebrow, title, subtitle, actions, back }) => (
  <header className={styles.header}>
    <div className={styles.text}>
      {back}
      {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}
      <h1 className={styles.title}>{title}</h1>
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
    </div>
    {actions && <div className={styles.actions}>{actions}</div>}
  </header>
);
